import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useDonationFormsStore } from '../store';
import ZakatDonationForm from './ZakatDonationForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ZakatModal',
  props: {
  amount: {
    type: Number,
    required: true
  },
  currency: {
    type: String,
    default: 'USD'
  },
  postId: {
    type: Number,
    default: 0
  }
},
  emits: ['close', 'success'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const store = useDonationFormsStore();

const props = __props;

const emit = __emit;

const showModal = ref(true);

const closeModal = () => {
  showModal.value = false;
  emit('close');
};

onMounted(async () => {
  // Initialize the store with Zakat-specific data
  await store.getData({ 
    vm: { 
      id: props.postId,
      dstyle: 1 // Use style 1 for Zakat donations
    } 
  });
  
  // Set the Zakat amount and purpose
  store.amount = props.amount;
  store.extras.donation_purpose = 'Zakat';
  store.currency = props.currency;
  
  // Disable recurring donations for Zakat
  store.recurring = false;
  
  // Show the modal
  store.showModal = true;
});

const __returned__ = { store, props, emit, showModal, closeModal, ZakatDonationForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})